import { render, staticRenderFns } from "./SystemSettingsGeneric.vue?vue&type=template&id=bab0910a&"
import script from "./SystemSettingsGeneric.vue?vue&type=script&lang=js&"
export * from "./SystemSettingsGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports